<div class="biometrics-container" *ngIf="activeTab.biometricData.enableBiometric">
    <div class="pin-container hide1">
        <div class="step-container flex">
            <!-- step-1 -->
            <span class="step-val active flex justify-space-between">
                <span class="step-circle" [ngClass]="{ 'active': activeTab.biometricData.step1Active&&!activeTab.biometricData.step1Failed,
                 'complete': activeTab.biometricData.step1Complete ,'failure': activeTab.biometricData.step1Failed }">

                    <span *ngIf="activeTab.biometricData.step1Complete||activeTab.biometricData.step1Failed">
                        <f-icon [iconConfig]="{iconName:(activeTab.biometricData.step1Complete ? 'check' : 'xmark'), iconType: 'solid', iconSize: 's'}"></f-icon>
                    </span>
                    <span class="step-no" *ngIf="!activeTab.biometricData.step1Complete&&!activeTab.biometricData.step1Failed">1</span>
                </span>Request Biometrics </span>
            <!-- step-2 -->
            <span class="step-val step-val-next" [ngClass]="{ 'active': activeTab.biometricData.step2Active&&!activeTab.biometricData.step2Failed, }" >
                <span class="step-circle" [ngClass]="{ 'active': activeTab.biometricData.step2Active, 'complete': activeTab.biometricData.step2Complete, 'failure':activeTab.biometricData.step2Failed }">
                    <span *ngIf="activeTab.biometricData.step2Complete||activeTab.biometricData.step2Failed">
                        <f-icon [iconConfig]="{iconName:(activeTab.biometricData.step2Complete ? 'check' : 'xmark'), iconType: 'solid', iconSize: 's'}"></f-icon>
                    </span>
                    <span class="step-no" *ngIf="!activeTab.biometricData.step2Complete&&!activeTab.biometricData.step2Failed">2</span>
                </span>Biometric verification</span>

        </div>
    </div>

    <div class="biometric-authentication">
        <!-- Step 1 content -->
        <div class="request-biometric" *ngIf="activeTab.biometricData.step1Active">
            <div class="error-wrapper" *ngIf="activeTab.biometricData.step1Failed">
                <f-alert variant="error"> The biometric verification request could not be completed. Click the Retry
                    button to try again.
                </f-alert>
            </div>
            <div class="biometric-content step1-content" *ngIf="!activeTab.biometricData.step1Failed">
                <p>This caller is registered for biometric verification. Send a biometric request to user's registered
                    mobile device to authenticate the call.</p>
                
            </div>
        </div>

         <!-- Step 2 content -->
        <div class="biometric-verification" *ngIf="activeTab.biometricData.step2Active">
            <div class="error-wrapper" *ngIf="activeTab.biometricData.step2Failed">
                <f-alert variant="error"> {{activeTab.biometricData.step2ErrorMsg}}
                </f-alert>
            </div>
            <div class="biometric-content step2-content" *ngIf="!activeTab.biometricData.step2Failed">
                <p> A biometric verification request has been sent to the caller's registered mobile device.</p>

                <div class="text-with-loader flex">
                      <p>Biometric verification status: <strong>In progress </strong></p> <mat-progress-spinner class="section-loader"
                        [color]="color" [mode]="mode" [value]="value" [diameter]="16"
                        style="display:inline-block;"></mat-progress-spinner>
                </div>

                    <div>
                        <p class="instruction-heading"><strong>What happens next?</strong></p>
                        <p>
                            1. The caller will receive a push notification on the registered mobile device.
                        </p>
                        <p>
                            2. The caller will be prompted to verify using Face ID or Fingerprint.
                        </p>
                        <p>
                            3. Once verification is complete, the call will get authenticated.
                        </p>
                    </div>

                     <p>Caller didn't receive the notification? <a href="javascript:void('0')" class="btn-alert-link" [ngClass]="biometricService.isbuttonDisabled ? 'disabledLink' : ''"  (click)="biometricService.sendBiometric()">Resend Biometric Request</a>
                    </p>
            </div>
        </div>

        <div class="btn-refresh-container flex">
            <div class="btn-controls" *ngIf="activeTab.biometricData.expiredAttempts < bioConfigData.MAX_EXPIRED_ATTEMPTS">
                <f-button text="Send Biometric Request" title="Send Biometric Request" type="button" *ngIf="!activeTab.biometricData.step1Complete && !activeTab.biometricData.step1Failed"
                    variant="progressive" (buttonClicked)="biometricService.sendBiometric()" [disabled]="biometricService.isbuttonDisabled"></f-button>
                     <f-button text="Cancel" title="Cancel" type="button"
                    variant="action" *ngIf="activeTab.biometricData.step2Active||activeTab.biometricData.step1Failed" (buttonClicked)="onCancel()"></f-button>
                     <f-button text="Retry" title="Retry" type="button" (buttonClicked)="onRetry()"  [disabled]="biometricService.isbuttonDisabled || activeTab.biometricData.expiredAttempts >= bioConfigData.MAX_EXPIRED_ATTEMPTS"
                    variant="progressive" *ngIf="activeTab.biometricData.step2Failed||activeTab.biometricData.step1Failed"></f-button>
            </div>
        </div>
    </div>
</div>